// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__QnPGy"};